/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
import React, { useEffect, useMemo } from 'react';
import { ConfigProvider } from 'antd';
import userInfo from '#/util/userInfo';
import { useCommonEnum } from '#/store';
import AdsMain from './AdsMain';
import { notLoginPage } from './common/constant';

const adapteOldCommonEnum = (commonEnum) => {
  // 适配旧的取值方式，这样业务无需改动
  window.__WKD_COMMON_ENUMS__ = commonEnum;
  window.__PACkAGE_LIST__ = commonEnum.packageList;
  delete commonEnum.packageList;
  window.__LANGUAGE_INFO_MAP__ = commonEnum.languageInfo;
  delete commonEnum.languageInfo;
  window.__CHANNEL_ID_LIST__ = commonEnum.rawChannel;
  delete commonEnum.rawChannel;
  window.__TIMEZONE_LIST__ = commonEnum.timezoneList;
  delete commonEnum.timezoneList;
  window.__COUNTRY_INFO_MAP__ = commonEnum.countryListMap;
  delete commonEnum.countryListMap;
  window.__COUNTRY_REGION_MAP__ = commonEnum.countryRegionMap;
  delete commonEnum.countryRegionMap;

  window.__WKD_COMMON_ENUMS__ = commonEnum;
};

/**
 * Wkd-Core App 入口
 * @returns App
 */
const App = () => {
  const [_, updateCommonEnum] = useCommonEnum();

  const Layout = useMemo(() => AdsMain, []);

  useEffect(() => {
    if (!userInfo.isLogged() && notLoginPage) {
      window.location.href = window.__LOGIN__;
    }

    if (userInfo.isLogged()) {
      adapteOldCommonEnum(window.__WKD_COMMON_ENUMS__);
    }
  }, []);

  return (
    <ConfigProvider autoInsertSpaceInButton={false}>
      <Layout />
    </ConfigProvider>
  );
};

export default App;
